import socketIO, { Socket } from 'socket.io-client';
import { urlsConfig } from 'src/configs';

let socket: Socket | undefined;

const socketListeners: { id: string; callback: (data: any) => void }[] = [];

export const createConnection = () => {
  if (socket?.connected) {
    return;
  }
  if (socket) {
    socket.off();
    socket.close();
  }

  socket = socketIO(urlsConfig.hymotsServerBaseURL.split('/api')[0]);

  socket.on('connect', () => {
    for (const { id, callback } of socketListeners) {
      socket?.off(id);
      socket?.on(id, callback);
    }
  });

  socket.on('connect_error', (err) => {
    // console.error('❌ Connection failed:', err.message);
  });

  socket.on('reconnect', (attemptNumber) => {
    // console.log(`🔄 Reconnected after ${attemptNumber} attempts. New ID:`, socket?.id);
  });
};

export const listenSocket = (id: string, callback: (data: any) => void) => {
  const exists = socketListeners.some((listener) => listener.id === id);
  if (!exists) {
    socketListeners.push({ id, callback });
  }

  socket?.off(id);
  socket?.on(id, callback);

  socket?.on('error', (error: any) => {
    console.error(`Socket error for event '${id}':`, error);
  });
};

export const closeSocket = () => {
  if (socket) {
    socket.off();
    socket.close();
    socket = undefined;
  }
};

export const isSocketConnected = (): boolean => {
  return socket?.connected ?? false;
};
